import {Component, Input} from '@angular/core';
import {BackButtonComponent} from "../back-button/back-button.component";
import {CommonModule} from '@angular/common';

@Component({
    selector: 'menu-buttons-header',
    templateUrl: './menu-buttons-header.component.html',
    styleUrls: ['./menu-buttons-header.component.scss'],
    imports: [BackButtonComponent, CommonModule],
    standalone: true
})
export class MenuButtonsHeaderComponent {

  @Input() label: string = '';
  @Input() sublabel?: string;

  constructor() {
  }
}
